export default __webpack_public_path__ + "static/media/landingPage_2.be32f9f5.jpg";